import { Checkbox, Grid, Typography } from '@mui/material';
import clsx from 'clsx';
import React, { useContext } from 'react';
import globalStyles from '../../../../../../assets/styles/global.module.scss';
import styles from '../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss';
import IconsColor from '../../../../../utility/iconsColor';
import GlobalTooltip from '../../../../../utility/tooltip/globalTooltip';
import { primaryColor } from '../../../../../../utils/colors';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';

const AI_EXTRACT_VALUE_INFO_TOOLTIP = "The user's response will be processed using AI to extract the actual answer.";
const AI_EXTRACT_DISABLED_TOOLTIP = "Please select a field before enabling AI Extraction.";

interface AiExtractValueLabelProps {
    variant?: 'default' | 'typography';
}

export const AiExtractValueLabel = ({ variant = 'default' }: AiExtractValueLabelProps) => {
    const labelContent = variant === 'typography' ? (
        <Typography className={clsx(globalStyles.displayFlex, globalStyles.secondaryFontSize, globalStyles.secondaryFontWeight)}>
            AI Extraction
        </Typography>
    ) : (
        <>AI Extraction</>
    );

    return (
        <Grid container className={clsx(globalStyles.displayFlex, globalStyles.gapOne)} flexWrap={"nowrap"}>
            <Grid item>
                {labelContent}
            </Grid>
            <Grid item>
                <GlobalTooltip
                    title={AI_EXTRACT_VALUE_INFO_TOOLTIP}
                    placement="top"
                    arrow
                >
                    <Grid item className={clsx(globalStyles.displayFlex, globalStyles.clickable)}>
                        <IconsColor fillColor={primaryColor} iconName="info" height={"15"} width={"15"} />
                    </Grid>
                </GlobalTooltip>
            </Grid>
        </Grid>
    );
};

interface AiExtractValueCheckboxProps {
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

export const AiExtractValueCheckbox = ({ checked, disabled = false, onChange }: AiExtractValueCheckboxProps) => {
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    
    return (
        <GlobalTooltip
            title={disabled ? AI_EXTRACT_DISABLED_TOOLTIP : ""}
            placement='top'
            arrow
        >
            <span>
                <Checkbox
                    className={styles.aiExtractionCheckbox}
                    checked={checked}
                    disabled={disabled || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                    onChange={(event) => onChange(event.target.checked)}
                />
            </span>
        </GlobalTooltip>
    );
};

interface AiExtractValueFieldProps {
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

export const AiExtractValueField = ({ checked, disabled = false, onChange }: AiExtractValueFieldProps) => {
    return (
        <Grid item className={clsx(globalStyles.fullwidth)}>
            <Grid container className={clsx(globalStyles.displayFlex)} gap={1}>
                <Grid item>
                    <AiExtractValueCheckbox checked={checked} disabled={disabled} onChange={onChange} />
                </Grid>
                <Grid item>
                    <AiExtractValueLabel variant="typography" />
                </Grid>
            </Grid>
        </Grid>
    );
};
